export default __webpack_public_path__ + "static/media/p10.21b13d32.jpeg";